<template>
  <ul class="navbar-nav">
    <li
      class="nav-item"
      :class="{
        active: route.path.includes('/companies'),
      }"
    >
      <router-link to="/companies" class="nav-link">
        Empresas
        <span class="sr-only" v-if="route.name == 'companies'">(atual)</span>
      </router-link>
    </li>
    <li
      class="nav-item"
      :class="{
        active: route.path.includes('/users'),
      }"
    >
      <router-link to="/users" class="nav-link">
        Usuários
        <span class="sr-only" v-if="route.path.includes('/users')"
          >(atual)</span
        >
      </router-link>
    </li>
    <li
      class="nav-item"
      :class="{
        active: route.name == 'machine-classes',
      }"
    >
      <router-link to="/machine-classes" class="nav-link">
        Tipos de equipamentos
        <span class="sr-only" v-if="route.name == 'machine-classes'"
          >(atual)</span
        >
      </router-link>
    </li>
    <li
      class="nav-item"
      :class="{
        active: route.path.includes('/noncompliance-models'),
      }"
    >
      <router-link to="/noncompliance-models" class="nav-link">
        Modelos de não conformidade
        <span
          class="sr-only"
          v-if="route.path.includes('/noncompliance-models')"
          >(atual)</span
        >
      </router-link>
    </li>
  </ul>
</template>

<script>
  import { useRouter } from 'vue-router'

  export default {
    setup() {
      const { currentRoute } = useRouter()

      return { route: currentRoute }
    },
  }
</script>
